import React, {useEffect} from "react";
import {
    Button,
    checkAndSetError,
    clearInputFormErrorFields,
    convertInputFormToObject,
    InputForm,
    inputFormIsValid,
    reinitializeInputFormFields,
    TextField,
    useInputForm,
} from "../../../../Components/Inputs";
import {GridCell, gridConstants} from "../../../../Components/Grid";
import {manufacturerModel} from "./manufacturerFactory";

interface ManufacturerViewProps {
    handleSaveManufacturer: (data: Record<string, unknown>) => void;
    handleReturn: () => void;
    manufacturer: Record<string, any>;
}

export const ManufacturerView = ({
                                    handleSaveManufacturer,
                                    handleReturn,
                                    manufacturer,
                                }: ManufacturerViewProps) => {
    const manufacturerForm = useInputForm(manufacturerModel(manufacturer));

    const handleSubmitClick = () => {
        clearInputFormErrorFields(manufacturerForm);

        checkAndSetError([
            manufacturerForm.name,
        ]);

        if (inputFormIsValid(manufacturerForm)) {
            const dirtyManufacturer = convertInputFormToObject(manufacturerForm);
            handleSaveManufacturer(dirtyManufacturer);
        }
    }

    useEffect(() => {
        if (manufacturer.manufacturerId !== manufacturerForm.manufacturerId.value)
            reinitializeInputFormFields(manufacturerForm, manufacturer);
    }, [manufacturer]);

    return <>
        <InputForm name={`manufacturerForm`}>
            <TextField {...manufacturerForm.name} medium_columns={gridConstants.column.SIX}/>

            <hr/>
            <GridCell className={`text-center`}>
                <Button isPrimary isCollapsed label={'Submit'} name={`btnSubmit`} onClick={handleSubmitClick}/>
                <Button isCollapsed label={'Cancel'} name={`btnCancel`} onClick={handleReturn}/>
            </GridCell>
        </InputForm>
    </>;
};
